<!-- @format -->

<ng-container *transloco="let t">
  <button
    class="event-button"
    [class]="viewType === 'timeGridWeek' ? 'time-grid-week' : 'day-grid-month'"
    (click)="openEventSummaryModal()">
    @if (viewType === "timeGridWeek") {
      <span class="event-info-row time-grid-week">{{ event.start | localTimeFormat }}–{{ event.end | localTimeFormat }}</span>
      <span class="event-info-row time-grid-week">{{ event.extendedProps.eventTitle }}</span>
    } @else {
      <span class="event-info-row day-grid-month">{{ event.extendedProps.eventTitle }}</span>
    }
  </button>
</ng-container>
